export default {
  activeDetail: '/activationScore/client/activeDetail',
  ruleDetail: '/activationScore/client/ruleDetail'
}
